import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { DropdownButton, MenuItem, Button } from 'react-bootstrap';

import { UsersAPI, LocationsAPI } from '../../lib/api';

import Safe from '../Components/Safe';
import Loading from '../Components/Loading';
import Flyout from '../Components/Flyout';
import UserDetail from '../Components/Detail/UserDetail';
import DataGrid from '../Components/DataGrid';
import Avatar from '../Components/Avatar';


const API = {
  users: new UsersAPI(),
  locations: new LocationsAPI(),
};

class UsersPageView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      flyoutUser: null,
    };

    this.fetch = this.fetch.bind(this);
    this.viewDetail = this.viewDetail.bind(this);
    this.closeDetail = this.closeDetail.bind(this);
    this.updateUser = this.updateUser.bind(this);
  }

  componentDidMount() {
    this.fetch();
  }

  componentDidUpdate(prevProps) {
    let fetch = false;
    if (prevProps.orgId !== this.props.orgId) {
      fetch = true;
    } else if (!_.isEqual(prevProps.payload, this.props.payload)) {
      fetch = true;
    }
    if (fetch) this.fetch();
  }

  fetch() {
    const { dispatch } = this.props;
    this.handleFetch().then((responses) => {
      dispatch({ type: 'PAGE_SUCCESS', responses });
    }).catch((error) => {
      dispatch({ type: 'PAGE_ERROR', error });
    });
  }

  async handleFetch() {
    const {
      dispatch,
      orgId,
    } = this.props;

    dispatch({ type: 'PAGE_FETCH' });

    const promises = [
      API.users.list(orgId).then(({ data }) => {
        dispatch({ type: 'PAGE_DATA_PART', part: 'users', data });
      }),
      API.locations.list(orgId).then(({ data }) => {
        dispatch({ type: 'PAGE_DATA_PART', part: 'locations', data });
      }),
    ];

    return Promise.all(promises);
  }

  async updateUser(user) {
    let error;
    if (user.id) {
      try {
        await API.users.update(this.props.orgId, user.id, user);
      } catch (e) {
        error = e;
      }
    } else {
      try {
        await API.users.create(this.props.orgId, user);
      } catch (e) {
        error = e;
      }
    }

    if (error) throw error;
    this.fetch();
    this.closeDetail();
  }

  viewDetail(flyoutUser) {
    this.setState({ flyoutUser });
  }

  closeDetail() {
    this.setState({ flyoutUser: null });
  }

  render() {
    const {
      data = {},
      // filters = {},
      // applyFilter,
      loading = false,
      user = {},
      payload = {},
    } = this.props;

    const {
      role, // eslint-disable-line
    } = user;

    const {
      toplevel,
      secondlevel,
    } = payload;

    const {
      flyoutUser = null,
    } = this.state;

    const {
      users = [],
      locations = [],
    } = data;

    console.log('users', users);
    console.log('locations', locations);

    let loadingStyles = {};
    if (loading) {
      loadingStyles = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        marginTop: '50px',
      };
    }

    return (
      <span
        className='dashboard'
        style={{ ...loadingStyles }}
      >
        {loading &&
          <Loading />
        }
        {!loading &&
          <div style={{ position: 'relative' }}>
            <div className='page-header'>
              <span>
                <span className='page-title' style={{ marginRight: '5px' }}>
                  <h1>
                    <Safe
                      render
                      safe
                      path={`pages.${toplevel}.${secondlevel}`}
                      value='title'
                    />
                  </h1>
                </span>
                <span className='page-description' style={{ fontSize: '0.6rem', marginTop: '5px' }}>
                  <p>| &nbsp;
                    <Safe
                      render
                      safe
                      path={`pages.${toplevel}.${secondlevel}`}
                      value='description'
                    />
                  </p>
                </span>
              </span>
              <span
                style={{
                  fontSize: '0.6rem',
                  marginTop: '5px',
                  position: 'absolute',
                  right: '0px',
                  top: '-5px',
                }}
              >
                <Button
                  bsStyle='primary'
                  bsSize='small'
                  onClick={() => {
                    this.viewDetail({
                      first_name: '',
                      last_name: '',
                      email: '',
                      locations: [],
                      roles: [],
                    });
                  }}
                >
                  Add New User
                </Button>
              </span>
            </div>
            <hr />
            <div className='row main-content' style={{ marginTop: '15px' }}>
              <div className='col-12 left-column'>
                <div className='column-content'>
                  <DataGrid
                    data={users}
                    columnHeaders='usersHeaders'
                    showPagination={false}
                    getTdProps={(state, rowInfo) => ({
                      onClick: (e, handleOriginal) => {
                        this.viewDetail(rowInfo.original);
                        if (handleOriginal) {
                          handleOriginal();
                        }
                      },
                      style: {
                        cursor: 'pointer',
                      },
                    })}
                    columns={[
                      {
                        id: 'avatar',
                        width: 50,
                        Cell: row => (
                          <div
                            style={{
                              position: 'absolute',
                              overflow: 'initial',
                            }}
                          >
                            <Avatar
                              user={{
                                username: `${row.first_name} ${row.last_name}`,
                                firstname: row.original.first_name,
                                lastname: row.original.last_name,
                                picture: row.original.picture,
                              }}
                              name={false}
                            />
                          </div>
                        ),
                      },
                      {
                        id: 'username',
                        accessor: row => `${row.first_name} ${row.last_name}`,
                      }, {
                        accessor: 'roles',
                        Cell: row => _.map(row.value, v => v.role_name).join(', '),
                      }, {
                        accessor: 'email',
                      }, {
                        accessor: 'locations',
                        Cell: row => _.map(row.value, v => _.filter([v.city, v.state, v.country], f => f).join(', ')).join(', '),
                      }, {
                        id: 'actions',
                        width: 40,
                        Cell: row => (
                          <div style={{ position: 'absolute' }}>
                            <DropdownButton
                              noCaret
                              pullRight
                              title={
                                <i
                                  style={{ padding: '10px' }}
                                  className='fas fa-ellipsis-v'
                                />
                            }
                              id={`actions-dropdown-${row.original.id}`}
                              ref={(c) => { this.orgMenu = c; }}
                              onClick={(e) => {
                                e.stopPropagation();
                              }}
                            >
                              <MenuItem
                                eventKey={0}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.viewDetail(row.original);
                                  document.dispatchEvent(new MouseEvent('click'));
                                }}
                              >
                              View Detail
                              </MenuItem>
                              <MenuItem
                                eventKey={0}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  console.warn('Unimplemented');
                                  document.dispatchEvent(new MouseEvent('click'));
                                // @TODO: delete
                                }}
                              >
                              Delete
                              </MenuItem>
                            </DropdownButton>
                          </div>
                        ),
                      }]}
                  />
                </div>
              </div>
            </div>
            <Flyout handleClose={this.closeDetail} isOpen={flyoutUser ? true : false}>
              <UserDetail
                user={flyoutUser || {}}
                locations={locations}
                orgId={this.props.orgId}
                close={this.closeDetail}
                update={this.updateUser || (() => {})}
              />
            </Flyout>
          </div>
        }
      </span>
    );
  }
}

UsersPageView.propTypes = {
  orgId: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  data: PropTypes.shape({}),
  user: PropTypes.shape({}),
  payload: PropTypes.shape({}),
  // applyFilter: PropTypes.func.isRequired,
  // filters: PropTypes.shape({}),
  loading: PropTypes.bool,
};

UsersPageView.defaultProps = {
  user: {},
  payload: {},
  data: {},
  // filters: {},
  loading: false,
};

export default UsersPageView;



// WEBPACK FOOTER //
// ./src/views/Pages/UsersPageView.js